import { render, staticRenderFns } from "./ui-bullets.vue?vue&type=template&id=1a186534&scoped=true&"
import script from "./ui-bullets.vue?vue&type=script&lang=js&"
export * from "./ui-bullets.vue?vue&type=script&lang=js&"
import style0 from "./ui-bullets.vue?vue&type=style&index=0&id=1a186534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a186534",
  null
  
)

export default component.exports